import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router';
import logo from '@/assets/599ad72d49c8887573a4750887df95ce60e36150.png';

export function Privacy() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-sm border border-slate-200 p-8 md:p-10 space-y-8">
        <div className="flex items-center justify-between gap-4">
          <Link to="/driver-mobile-auth" className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-200 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Geri Dön
          </Link>
          <img src={logo} alt="Yük Ortağım Logo" className="h-14 w-auto rounded-2xl border border-slate-200 bg-white p-2 shadow-sm" />
        </div>
        <div>
          <div className="inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-sm font-medium text-emerald-800 mb-4">Yük Ortağım Uygulaması</div>
          <h1 className="text-3xl font-bold text-slate-900">Gizlilik ve Çerez Politikası</h1>
        </div>

        <section className="space-y-4 text-slate-700 leading-7">
          <h2 className="text-2xl font-semibold text-teal-800 border-b border-slate-200 pb-2">A. Gizlilik Politikası</h2>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">1. Politika Kapsamı ve Uygulama</h3>
            <p>Doğuş Çay ve Gıda Maddeleri Üretim Pazarlama İthalat İhracat A.Ş. (“Şirket”) olarak, Yük Ortağım Uygulaması, internet sitesi ve ilgili dijital platformlarımızı kullanan gerçek kişilerin kişisel verilerinin korunmasına önem vermekteyiz.</p>
            <p>Kişisel verileriniz, başta 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) olmak üzere ilgili mevzuata uygun şekilde işlenmekte, saklanmakta, gerektiğinde aktarılmakta ve mevzuata uygun şekilde silinmekte, yok edilmekte veya anonim hale getirilmektedir.</p>
            <p>İşbu politika; kullanıcılarımız, ziyaretçilerimiz, tedarikçilerimiz, iş ortaklarımız ve dijital platformlarımızı kullanan diğer gerçek kişilere ait kişisel verilerin hangi kapsamda işlendiğini açıklamaktadır.</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">2. Tanımlar</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Açık Rıza:</strong> Belirli bir konuya ilişkin, bilgilendirilmeye dayanan ve özgür iradeyle açıklanan onay.</li>
              <li><strong>Kişisel Veri:</strong> Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi.</li>
              <li><strong>Özel Nitelikli Kişisel Veri:</strong> Sağlık, biyometrik veri, ceza mahkumiyeti gibi özel koruma gerektiren veriler.</li>
              <li><strong>Veri Sahibi / İlgili Kişi:</strong> Kişisel verisi işlenen gerçek kişi.</li>
              <li><strong>Veri Sorumlusu:</strong> Kişisel verilerin işleme amaç ve vasıtalarını belirleyen tüzel kişi.</li>
              <li><strong>KVKK:</strong> 6698 sayılı Kişisel Verilerin Korunması Kanunu.</li>
              <li><strong>Uygulama:</strong> Yük Ortağım mobil uygulaması ve ilişkili dijital hizmetler.</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">3. Kişisel Verilerin İşlenmesindeki İlkeler</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>Hukuka ve dürüstlük kurallarına uygun işleme</li>
              <li>Doğru ve gerektiğinde güncel olma</li>
              <li>Belirli, açık ve meşru amaçlarla işleme</li>
              <li>İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü olma</li>
              <li>İlgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza edilme</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">4. İşlenen Kişisel Veriler</h3>
            <p>Yük Ortağım Uygulaması ve ilişkili platformlar üzerinden aşağıdaki veri kategorileri işlenebilir:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Kimlik Verileri:</strong> Ad, soyad, T.C. kimlik numarası, kullanıcı ID bilgisi</li>
              <li><strong>İletişim Verileri:</strong> Telefon numarası, adres, e-posta adresi</li>
              <li><strong>Lokasyon Verileri:</strong> Yük alma ve teslim noktaları, anlık veya işleme konu konum bilgileri</li>
              <li><strong>İşlem Verileri:</strong> Taşıma kayıtları, siparişler, talepler, uygulama içi tercihler</li>
              <li><strong>Finansal Veriler:</strong> Fatura ve ödeme süreçlerine ilişkin bilgiler</li>
              <li><strong>İşlem Güvenliği Verileri:</strong> Şifre bilgileri, IP adresi, oturum kayıtları, log kayıtları</li>
              <li><strong>Talep/Şikayet Verileri:</strong> Destek başvuruları, geri bildirimler, değerlendirmeler</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">5. Kişisel Verilerin İşlenme Amaçları ve Hukuki Sebepleri</h3>
            <p>Kişisel verileriniz aşağıdaki amaçlarla işlenebilir:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Uygulama üyelik ve hesap süreçlerinin yürütülmesi</li>
              <li>Taşıma, sevkiyat, teslimat ve lojistik operasyonlarının yönetilmesi</li>
              <li>Müşteri destek ve çağrı merkezi hizmetlerinin sunulması</li>
              <li>Faturalandırma ve ödeme süreçlerinin yürütülmesi</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>Bilgi güvenliği ve sistem güvenliğinin sağlanması</li>
              <li>Talep, öneri ve şikayetlerin takibi</li>
              <li>Açık rıza verilmesi halinde kampanya, tanıtım ve bilgilendirme yapılması</li>
            </ul>
            <p>Bu işlemler; sözleşmenin kurulması veya ifası, hukuki yükümlülüğün yerine getirilmesi, veri sorumlusunun meşru menfaati ve gerektiğinde açık rıza hukuki sebeplerine dayanılarak gerçekleştirilebilir.</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">6. Kişisel Verilerin Aktarılması</h3>
            <p>Kişisel verileriniz, yukarıda belirtilen amaçlarla sınırlı olmak üzere aşağıdaki taraflara aktarılabilir:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>İş ortakları ve tedarikçiler</li>
              <li>Ödeme kuruluşları ve finansal hizmet sağlayıcıları</li>
              <li>Lojistik, nakliye ve operasyon süreçlerinde görev alan taraflar</li>
              <li>Bulut, hosting ve altyapı hizmet sağlayıcıları</li>
              <li>Kanunen yetkili kamu kurum ve kuruluşları</li>
              <li>Kanunen yetkili özel hukuk kişileri</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">7. Kişisel Verilerin Güvenliği</h3>
            <p>Şirket, kişisel verilerin hukuka aykırı işlenmesini ve erişimini önlemek, kişisel verilerin korunmasını sağlamak amacıyla uygun teknik ve idari tedbirleri almaktadır. Erişim kontrolü, loglama, şifreleme, sistem güvenliği ve yetki yönetimi gibi mekanizmalar bu kapsamda uygulanmaktadır.</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">8. Sosyal Medya ve Üçüncü Taraf Bağlantılar</h3>
            <p>Uygulama veya internet sitemiz üzerinden üçüncü taraf sitelere veya sosyal medya platformlarına bağlantılar verilebilir. Bu platformların veri işleme faaliyetlerinden Şirket sorumlu değildir. İlgili platformların gizlilik politikalarının ayrıca incelenmesi önerilir.</p>
          </div>
        </section>

        <section className="space-y-4 text-slate-700 leading-7">
          <h2 className="text-2xl font-semibold text-teal-800 border-b border-slate-200 pb-2">B. Çerez Politikası</h2>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">1. Çerez Nedir?</h3>
            <p>Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcınız aracılığıyla cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler, site deneyiminin iyileştirilmesi, tercihlerin hatırlanması, güvenlik ve analiz amaçlarıyla kullanılabilir.</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">2. Çerezlerin Kullanımı</h3>
            <p>İnternet sitemizde aşağıdaki türlerde çerezler kullanılabilir:</p>
            <div className="overflow-x-auto mt-4">
              <table className="w-full min-w-[850px] border border-slate-200 text-sm">
                <thead className="bg-emerald-50 text-teal-900">
                  <tr>
                    <th className="border border-slate-200 px-3 py-3 text-left">Çerez Türü</th>
                    <th className="border border-slate-200 px-3 py-3 text-left">Açıklama</th>
                    <th className="border border-slate-200 px-3 py-3 text-left">Amaç</th>
                    <th className="border border-slate-200 px-3 py-3 text-left">Veri Aktarımı</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-200 px-3 py-3">Zorunlu Çerezler</td>
                    <td className="border border-slate-200 px-3 py-3">Sitenin temel fonksiyonlarının çalışması için gerekli çerezlerdir.</td>
                    <td className="border border-slate-200 px-3 py-3">Oturum yönetimi, güvenlik, dil seçimi</td>
                    <td className="border border-slate-200 px-3 py-3">Gerekli olduğu ölçüde hizmet sağlayıcılara aktarılabilir</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-200 px-3 py-3">Performans Çerezleri</td>
                    <td className="border border-slate-200 px-3 py-3">Site performansını ve kullanım istatistiklerini analiz etmeye yarar.</td>
                    <td className="border border-slate-200 px-3 py-3">Hız, hata tespiti, kullanım ölçümü</td>
                    <td className="border border-slate-200 px-3 py-3">Anonim veya toplulaştırılmış veri aktarımı olabilir</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-200 px-3 py-3">İşlevsel Çerezler</td>
                    <td className="border border-slate-200 px-3 py-3">Kullanıcı tercihlerinin hatırlanmasını sağlar.</td>
                    <td className="border border-slate-200 px-3 py-3">Dil, oturum ve tercih yönetimi</td>
                    <td className="border border-slate-200 px-3 py-3">Sınırlı aktarım olabilir</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-200 px-3 py-3">Reklam / Pazarlama Çerezleri</td>
                    <td className="border border-slate-200 px-3 py-3">Kullanıcıya ilgi alanına uygun içerik ve reklam sunulmasına yardımcı olur.</td>
                    <td className="border border-slate-200 px-3 py-3">Kampanya ve reklam performansı ölçümü</td>
                    <td className="border border-slate-200 px-3 py-3">Üçüncü taraf reklam sağlayıcılarla paylaşım olabilir</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">3. Çerezlerin Kontrolü ve Silinmesi</h3>
            <p>Tarayıcı ayarlarınız üzerinden çerezleri kabul edebilir, reddedebilir veya silebilirsiniz. Ancak bazı çerezlerin devre dışı bırakılması, internet sitesinin veya uygulamanın bazı bölümlerinin düzgün çalışmamasına neden olabilir.</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-teal-900">4. Kişisel Verilere İlişkin Haklar</h3>
            <p>KVKK’nın 11. maddesi uyarınca ilgili kişi olarak; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, işleme amacını öğrenme, eksik veya yanlış işlenmişse düzeltilmesini isteme, silinmesini veya yok edilmesini talep etme ve kanuni koşullar dahilinde itiraz etme haklarına sahipsiniz.</p>
            <p>Bu kapsamda başvurularınızı, Şirket’in güncel iletişim kanalları üzerinden yazılı olarak veya mevzuatta öngörülen diğer yöntemlerle iletebilirsiniz.</p>
          </div>
        </section>


      </div>
    </div>
  );
}
